import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { DialogContent } from '@mui/material';
import { useTheme } from 'styled-components';

import { TenantEntities } from '@/features/canvas/api/tenant-sso';
import PublishDialogFormSso from '@/features/canvas/components/PublishDialogFormSso/PublishDialogFormSso';
import { getPublicLinkViewers } from '@/features/publicLinks/api';
import { Dialog } from '@/features/ui/components/Dialog';

const ViewerAccessDialog = ({
  open,
  onClose,
  id,
}: {
  id: number | null;
  onClose: (v: boolean) => void;
  open: boolean;
}) => {
  const theme = useTheme();
  const [selectedEntities, setSelectedEntities] = useState<TenantEntities>({
    groups: [],
    viewers: [],
  });
  const [isOpen, setIsOpen] = useState(false);

  const { refetch } = useQuery(
    getPublicLinkViewers.name,
    () => getPublicLinkViewers({ id: Number(id) }),
    {
      onSuccess: data => {
        setSelectedEntities(data);
        setIsOpen(true);
      },
      enabled: open,
    }
  );

  useEffect(() => {
    if (open) {
      void refetch();
    }
  }, [open, refetch]);

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
        onClose(false);
      }}
    >
      <DialogContent
        sx={{
          color: theme.palette.brand.textPrimary,
          padding: '0 2rem',
          overflow: 'visible',
        }}
      >
        <PublishDialogFormSso
          id={Number(id)}
          selectedEntities={selectedEntities}
          setSelectedEntities={setSelectedEntities}
          isDisabled={false}
          isAccessPage
        />
      </DialogContent>
    </Dialog>
  );
};

export default ViewerAccessDialog;
